<template>
  <Modal
    class="product-details-modal"
    title=""
    :is-open="isOpen"
    data-testid="product-details-modal"
    @close="$emit('close')"
  >
    <template v-if="productDetails?.status === EOrderStatus.CANCELED">
      <HelperViewStatus
        data-testid="product-details-modal-canceled-status"
        status="negative"
        :title="productDetails?.title"
        :description="productDetails?.description?.label"
      />
    </template>

    <template v-else>
      <div class="product-details-modal__content">
        <Heading :level="3">{{ product?.name }}</Heading>
        <BaseText size="p5" :color="productDetails?.description?.color">
          {{ productDetails?.description.label || '-' }}
        </BaseText>
        <div v-if="productDetails?.list" class="product-details-modal__list">
          <ListDisplay
            v-for="(item, index) in productDetails.list"
            :key="index"
            class="product-details-modal__list__item"
            :has-divider="index !== productDetails.list.length - 1"
            :title="item.label"
            :value="item.value"
          />
        </div>
      </div>
    </template>

    <template v-if="productDetails?.button" #buttonContainer>
      <ButtonContainer>
        <template #button-primary>
          <ButtonSecondary
            :label="productDetails.button.label"
            @click="handleButtonAction(productDetails.button.action)"
          />
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  Modal,
  HelperViewStatus,
  Heading,
  BaseText,
  ListDisplay,
  ButtonSecondary,
  ButtonContainer
} from '@warrenbrasil/nebraska-web';
import {
  IOrderProduct,
  EOrderStatus,
  EOrderButtonAction
} from '@/modules/wealth/services/portfolio-orders';

const router = useRouter();

interface Props {
  isOpen: boolean;
  product: IOrderProduct | null;
}
const props = defineProps<Props>();

const productDetails = computed(() => {
  return props.product?.details;
});

function handleButtonAction(action: string) {
  if (action === EOrderButtonAction.OPEN_TRANSIT) {
    navigateToTransactions();
  }
}

function navigateToTransactions() {
  router.push({
    path: '/transactions',
    query: { filter: 'future_transactions' }
  });
}
</script>

<style lang="less" scoped>
.product-details-modal {
  :deep(.base-modal--wrapper) {
    width: 592px;
    max-width: 592px;
  }

  :deep(.modal-content) {
    padding: 0 @size-spacing-x1000 @size-spacing-x1000;
  }

  &__content {
    width: 100%;
    text-align: left;
  }

  &__list {
    margin-top: @size-spacing-x500;

    &__item {
      margin-bottom: @size-spacing-x450;
      padding-bottom: @size-spacing-x450;

      &:last-of-type {
        margin-bottom: 0;
        padding-bottom: 0;
      }
    }
  }
}
</style>
